import React, { Component } from "react";
import {Section,Title} from 'bloomer'
import {push} from 'gatsby'
import NewsList from '../components/body/profile';
import Modal from '../components/body/modal';
import Hero from '../components/hero'
import {HTMLContent} from './body/content'


import PropTypes from "prop-types";

class NewsListTemplate extends Component {
  constructor(){
    super()
    this.state = { isActive: false };
    this.handleClick= this.handleClick.bind(this);
    //this.handleClose= this.handleClose.bind(this)
  }

  handleClick(profileItem){
    // console.log(profileItem)
    push(profileItem.link)
  }


  render() {
    const {newsList,heroClass}= this.props
    return (
      <div>
        <div id="carousel-wrap">
          <Hero
            className={heroClass}
            images={[]}
            getBody={()=><Title
              style={{marginTop:'1em'}}
              className='is-hidden-mobile'>
              News
            </Title>}
          />
        </div>
        <Section className={'row'}>
          <Title className='is-hidden-desktop'>
            News
          </Title>
          <NewsList
            isLargeMode={true}
            profiles={newsList}
            onClick={this.handleClick}
          />

          <Modal
            title={this.state.title}
            onClose={this.handleClose}
            isActive={this.state.isActive}>
            {this.state.description &&
            <HTMLContent
              content={this.state.description}
              className='content'
            />
            }
          </Modal>
        </Section>
      </div>
    );
  }
}

NewsListTemplate.propTypes = {
  newsList:PropTypes.array,
  heroClass:PropTypes.string,
};
NewsListTemplate.defaultProps = {

};

export default NewsListTemplate;
